
// Define a global function that sets up hover logic for size guides
window.initSizeGuideScript = function () {

  // Hover effects on table cells
  const cells = document.querySelectorAll('.table.table-striped td');

  cells.forEach(cell => {
    cell.addEventListener('mouseover', () => {
      cell.classList.add('size-guide__size-chart--hover');

      const colIndex = [...cell.parentNode.children].indexOf(cell);
      const rows = document.querySelectorAll('.table.table-striped tr');

      rows.forEach(row => {
        const sibling = row.children[colIndex];
        if (sibling) sibling.classList.add('size-guide__size-chart--sibling-hover');
      });

      [...cell.parentNode.children].forEach((sibling, i) => {
        if (i < colIndex) {
          sibling.classList.add('size-guide__size-chart--sibling-hover');
        }
      });

      const header = document.querySelector('.size-guide__size-chart-header tr');
      if (header?.children[colIndex]) {
        header.children[colIndex].classList.add('size-guide__size-chart--sibling-hover');
      }
    });

    cell.addEventListener('mouseout', () => {
      cell.classList.remove('size-guide__size-chart--hover');
      document.querySelectorAll('.size-guide__size-chart--sibling-hover').forEach(el =>
        el.classList.remove('size-guide__size-chart--sibling-hover')
      );
    });
  });


};

document.addEventListener('DOMContentLoaded', () => {
  // Run once on page load
  window.initSizeGuideScript();

  // Run again after variant swatch change via theme's event
  document.addEventListener('variant:change', () => {
    //console.log('[Size Guide] variant:change detected');
    window.initSizeGuideScript();
  });
});




// Handle size guide navigation with event delegation
document.addEventListener('DOMContentLoaded', function() {
  // Use event delegation on document or a stable parent element
  document.addEventListener('click', function(e) {
    // Check if clicked element is a size guide nav button
    if (e.target.matches('.size-guide-nav-btn') || e.target.closest('.size-guide-nav-btn')) {
      const button = e.target.matches('.size-guide-nav-btn') ? e.target : e.target.closest('.size-guide-nav-btn');
      const targetId = button.getAttribute('data-target');
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        targetElement.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
        
        // Remove active state from all buttons
        const navButtons = document.querySelectorAll('.size-guide-nav-btn');
        navButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
      }
    }
  });
});



